export class ProgressBar {
    progressBarValue: string;
    progressBarWidthPercentage: number;
    progressCurrentValue: string;
}
